import React from 'react';

import { useIntl } from 'react-intl';

import AlertIcon from '@atlaskit/icon/core/alert';
import { token } from '@atlaskit/tokens';

import { AdditionalNoteBase } from './AdditionalNoteBase';
import { messages } from './messages';

export const HighlightRiskField = ({
	highlight,
}: {
	highlight?: { summary: string; description: string };
}): React.JSX.Element => {
	const intl = useIntl();
	return (
		<AdditionalNoteBase
			icon={<AlertIcon size="medium" label="" color={token('color.icon.accent.red')} />}
			title={highlight?.summary || intl.formatMessage(messages.newRisk)}
			description={highlight?.description}
			testId="project-status-update-action-renderer.ui.highlight-risk"
		/>
	);
};
